import getAccountByReferenceFromProduct from '../resolvers/getAccountByReferenceFromProduct';
import isAccountApplicableProduct from '../resolvers/isAccountApplicableProduct';

/**
 * Returns a copy of the product instance with applied (overridden) properties from the provided account.
 *
 * @param product
 * @param account
 * @return {*&{merge: {}}}
 */
export default (product, account) => {
    // Only doBoard supports accounts.
    if (isAccountApplicableProduct(product)) {
        return product;
    } else {
        if (!!account) {
            account = getAccountByReferenceFromProduct(product, account) ?? account;
        } else {
            return product;
        }

        let merge = {};
        for (const prop in account) {
            if (prop !== 'account_id') {
                merge[`account_${prop}`] = account[prop];
            }
        }
        return { ...product, ...merge };
    }
}
